import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Base from "../Base";
import { Row, Col, Button, Form, Tab, Tabs, Table, Breadcrumb, Container } from "react-bootstrap";
import { FaCogs, FaCopy, FaPlus } from "react-icons/fa";
import BulkImportModal from "./BulkImportModal";
import AddEditHsnSacModal from "./AddEditHsnSacModal";
import RoleSelectionPopup from "./hierarchy";
import DescriptionCell from "./descriptionCell";
import Spinner from "react-bootstrap/Spinner";
import {
  getHsnSac,
  resetHsnSacState,
  HsnSacPendingList,
  BulkAction,
  QueryList,
} from "../../slices/hsnSacReducer";
import { useSelector, useDispatch } from "react-redux";
import PaginationComponent from "../common/Pagination";
import Alert from "react-bootstrap/Alert";
import { truncateText } from "../../utils";
import { extractErrorMessage } from "../../constants/common";
import toast from "react-hot-toast";
const HsnSacComponent = () => {
  const [selectedAllCheckbox, setSelectedAllCheckbox] = useState(0);
  const [updatedTime, setUpdatedTime] = useState(null);
  const [activeTab, setActiveTab] = useState("HSN");
  const [showBulkImport, setShowBulkImport] = useState(false);
  const [showAddEditModal, setShowAddEditModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showHierarchy, setShowHierarchy] = useState(false);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [copiedIndex, setCopiedIndex] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);
  const [current_page, setCurrentPage] = useState(1);
  const [query, setQuery] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    hsnSacData,
    pendingHsnSacData,
    queryList,
    bulkActionSuccess,
    total_count,
    loading,
    error,
    success,
    successMsg,
  } = useSelector((state) => state.hsnSac);
  const { role_id: roleId } = useSelector((state) => state.common);
  const per_page = 25;

  const handleCheckboxChange = (id) => {
    setSelectedRows((prevSelectedRows) =>
      prevSelectedRows.includes(id)
        ? prevSelectedRows.filter((rowId) => rowId !== id)
        : [...prevSelectedRows, id]
    );
  };

  const handleSearchChange = (e) => {
    setQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const params = { page: current_page, perpage: per_page };
        if (query.trim() && activeTab !== "QUERIES") {
          params.query = query.trim();
        }

        if (selectedStatus) {
          params.status = [selectedStatus === "Completed" ? 1 : 0];
        }

        switch (activeTab) {
          case "HSN":
          case "SAC":
            await dispatch(getHsnSac({ ...params, types: activeTab })).unwrap();
            break;
          case "HSN_PENDING":
            await dispatch(
              HsnSacPendingList({ ...params, types: "HSN" })
            ).unwrap();
            break;
          case "SAC_PENDING":
            await dispatch(
              HsnSacPendingList({ ...params, types: "SAC" })
            ).unwrap();
            break;
          case "QUERIES":
            await dispatch(QueryList(params)).unwrap();
            break;
          default:
            console.warn("Unhandled tab type:", activeTab);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [dispatch, activeTab, selectedStatus, query, current_page]);

  const handlePagination = async (page) => {
    try {
      setCurrentPage(page);
      const params = { page: page, perpage: per_page };
      if (query.trim() && activeTab !== "QUERIES") {
        params.query = query.trim();
      }

      if (selectedStatus) {
        params.status = [selectedStatus === "Completed" ? 1 : 0];
      }

      switch (activeTab) {
        case "HSN":
        case "SAC":
          await dispatch(getHsnSac({ ...params, types: activeTab })).unwrap();
          break;
        case "HSN_PENDING":
          await dispatch(
            HsnSacPendingList({ ...params, types: "HSN" })
          ).unwrap();
          break;
        case "SAC_PENDING":
          await dispatch(
            HsnSacPendingList({ ...params, types: "SAC" })
          ).unwrap();
          break;
        case "QUERIES":
          await dispatch(QueryList({ ...params, types: "QUERIES" })).unwrap();
          break;
        default:
          console.warn("Unhandled tab type for pagination:", activeTab);
      }
    } catch (error) {
      console.error("Error during pagination:", error);
    }
  };

  const handleEditClick = (item) => {
    const updateFormData = {
      id: item?.id,
      hsn_number: item?.hsn_number,
      description: item?.description,
      types: item?.type,
      rate: item?.rate,
    };
    setEditData(updateFormData);
    setShowAddEditModal(true);
    setIsUpdate(true);
    dispatch(resetHsnSacState());
  };

  const handleAddClick = () => {
    setEditData(null);
    setIsUpdate(false);
    setShowAddEditModal(true);
    dispatch(resetHsnSacState());
  };

  const handleApproveReject = async (ids, approve, type) => {
    try {
      const response = await dispatch(
        BulkAction({
          is_select_all: selectedAllCheckbox,
          updated_time: updatedTime,
          approval_ids: ids,
          approve,
          type,
        })
      ).unwrap();
      console.log("response:", response)
      toast.success(response?.message || "Action completed successfully");

      setSelectedRows([]);
      setSelectedAllCheckbox(0);
      setUpdatedTime(null);

      // Refresh the relevant list
      switch (activeTab) {
        case "HSN_PENDING":
          await dispatch(HsnSacPendingList({ page: 1, perpage: per_page, types: "HSN" })).unwrap();
          break;
        case "SAC_PENDING":
          await dispatch(HsnSacPendingList({ page: 1, perpage: per_page, types: "SAC" })).unwrap();
          break;
        default:
          console.warn("Unhandled tab type:", activeTab);
      }
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      toast.error(errorMessage);
    }
  };

  const renderTableContent = (type) => {
    try {
      if (hsnSacData.length == 0) {
        console.log("hsnSacData", hsnSacData);
        return (
          <tr>
            <td colSpan="100%" style={{ textAlign: "left", padding: "20px" }}>
              No data available
            </td>
          </tr>
        );
      }
      return hsnSacData
        .filter((item) => item.type === type)
        .map((item, index) => (
          <tr
            key={index}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
          >
            <td className="text-left position-relative">
              {item.hsn_number}

              {/* Copy Button on Hover */}
              {hoveredRow === index && (
                <Button
                  variant="info"
                  size="sm"
                  className="copy-button position-absolute"
                  style={{ top: 27, right: 27 }}
                  onClick={() => handleCopy(item.hsn_number, index)}
                >
                  <FaCopy style={{ fontSize: "10px" }} />
                </Button>
              )}

              {/* "Copied" Message Overlay */}
              {copiedIndex === index && (
                <div
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    paddingLeft: "5px",
                    paddingTop: "2px",
                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                    fontSize: "9px",
                    fontWeight: "bold",
                    color: "green",
                    pointerEvents: "none",
                    animation: "fadeInOut 3s ease-in-out",
                    zIndex: 10,
                  }}
                >
                  Copied
                </div>
              )}
            </td>

            <DescriptionCell
              description={item.description}
              progressbar={false}
              className="text-left align-top"
            />

            {/* <td className="text-left">
              {item.description}
            </td> */}

            <td className="text-left">{item.rate}%</td>
            <td className="text-left">{item.updated_time_formatted.split("T")[0]}</td>
            <td style={{ display: "Flex", justifyContent: "center" }}>
              <Button
                className="me-2 fw-semibold"
                variant="success"
                onClick={() => handleEditClick(item)}
              >
                Update
              </Button>
              {/* <Button
                className="me-2"
                variant="danger"
                onClick={() => handleEditClick(item)}
              >
                Delete
              </Button> */}
            </td>
          </tr>
        ));
    } catch (error) {
      console.error("Error handling renderTableContent action:", error);
    }
  };

  const renderPendingTableContent = (type) => {
    try {
      if (pendingHsnSacData.length === 0) {
        return (
          <tr className="text-left">
            <td colSpan="100%" style={{ textAlign: "center", padding: "20px" }}>
              No pending data available
            </td>
          </tr>
        );
      }
      return pendingHsnSacData
        .filter((item) => item.type === type)
        .map((item, index) => (
          <tr
            key={index}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
          >

            <td className="text-left">
              <Form.Check
                type="checkbox"
                onChange={() => handleCheckboxChange(item.id)}
                checked={selectedRows.includes(item.id)}
                className="custom-checkbox"
                style={{ marginLeft: '26px' }}
                disabled={item.action_required === 0}
              />
            </td>
            <td className="text-left position-relative">
              {item.hsn_number}

              {/* Copy Button on Hover */}
              {hoveredRow === index && (
                <Button
                  variant="info"
                  size="sm"
                  className="copy-button position-absolute"
                  style={{ top: 64, right: -3 }}
                  onClick={() => handleCopy(item.hsn_number, index)}
                >
                  <FaCopy style={{ fontSize: "10px" }} />
                </Button>
              )}

              {/* "Copied" Message Overlay */}
              {copiedIndex === index && (
                <div
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    paddingLeft: "5px",
                    paddingTop: "2px",
                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                    fontSize: "9px",
                    fontWeight: "bold",
                    color: "green",
                    pointerEvents: "none",
                    animation: "fadeInOut 3s ease-in-out",
                    zIndex: 10,
                  }}
                >
                  Copied
                </div>
              )}
            </td>
            <td>
              <DescriptionCell
                description={item.description}
                levels={item.levels}
                progressbar={true}
                className="h-full flex flex-col !justify-center !items-center !text-center mb-3"
              />
            </td>

            <td className="text-left">{item.rate}%</td>
            <td className="text-left">{item.action}</td>
            <td className="text-left">{item.updated_time_formatted.split("T")[0]}</td>
            <td className="text-center">
              {item.action_required === 1 ? (
                <div className="d-flex justify-content-center gap-2"> {/* Added a flex container */}
                  <Button
                    className="fw-bold"
                    variant="success"
                    onClick={() => handleApproveReject([item?.id], 1)}
                    style={{ width: "100px" }}
                  >
                    Approve
                  </Button>
                  <Button
                    className="fw-bold" // Removed d-flex and align-items-left
                    variant="danger"
                    onClick={() => handleApproveReject([item?.id], 2)}
                    style={{ width: "100px" }}
                  >
                    Reject
                  </Button>
                </div>
              ) : (
                <Button variant="secondary" className="rounded-pill fw-semibold" disabled>
                  Pending
                </Button>
              )}
            </td>
          </tr>
        ));
    } catch (error) {
      console.error("Error handling renderPendingTableContent action:", error);
    }
  };

  const handleQueryClick = (query) => {
    navigate(`/query-details/${query.client_details.id}/${query.id}`);
  };

  const handleMouseEnter = (index) => {
    setHoveredRow(index);
  };

  const handleMouseLeave = () => {
    setHoveredRow(null);
  };

  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(null), 2000);
  };
  const handleSelectAll = () => {
    const selectableItems = pendingHsnSacData.filter(
      (item) => item.action_required === 1
    );
    const selectableIds = selectableItems.map((item) => item.id);

    if (selectedRows.length === selectableIds.length) {
      // Unselect All
      setSelectedRows([]);
      setSelectedAllCheckbox(0);
      setUpdatedTime(null);
    } else {
      // Select All
      setSelectedRows(selectableIds);
      setSelectedAllCheckbox(1);

      if (selectableItems.length > 0) {
        setUpdatedTime(selectableItems[0].updated_time); // Store latest item's time
      }
    }
  };

  return (
    <Base hideDatepicker={true} header_title="HSN">
      <Container>
        <div className=" position-relative">
          <div className="d-flex justify-content-between align-items-center">
            <Breadcrumb className="m-0">
              <Breadcrumb.Item linkAs={NavLink} linkProps={{ to: '/' }}>
                Dashboard
              </Breadcrumb.Item>
              <Breadcrumb.Item active>HSN-SAC</Breadcrumb.Item>
            </Breadcrumb>
          </div>


        </div>
        <div className="mb-4 d-flex justify-content-between align-items-center">
          <h2 className="fs-3 fw-semibold">HSN-SAC</h2>
          {/* {roleId === 1 && (
            <button
              className="p-0 d-flex align-items-center border-0 bg-transparent"
              onClick={() => setShowHierarchy(true)}
            >
              <FaCogs className="me-2" style={{ color: "#0d6efd" }} />
              <span style={{ color: "#0d6efd" }}>HSN/SAC Approval Hierarchy</span>
            </button>
          )} */}
        </div>
        <div className="mt-4">
          <Tabs
            fill
            variant="underline"
            transition={false}
            activeKey={activeTab}
            onSelect={(key) => {
              if (key !== activeTab) {
                setActiveTab(key);
                setCurrentPage(1);
                dispatch(resetHsnSacState());
                setQuery("");
              }
            }}
            className="mb-4 custom-tabs"
          >
            <Tab eventKey="HSN" title="HSN">
              <Row className="align-items-center py-3 px-2 mb-4 rounded shadow-sm">
                <Col xs={12} className="d-flex flex-wrap align-items-center gap-2 w-100">
                  <Button
                    className="d-flex align-items-center fw-semibold"
                    style={{ minWidth: '120px' }}
                    variant="primary"
                    onClick={() => setShowBulkImport(true)}
                  >
                    <FaPlus className="me-2" />
                    Bulk Import
                  </Button>

                  <Button
                    className="d-flex align-items-center fw-semibold"
                    style={{ minWidth: '105px' }}
                    variant="primary"
                    onClick={handleAddClick}
                  >
                    <FaPlus className="me-2" />
                    Add New
                  </Button>

                  <Form.Control
                    type="text"
                    placeholder="Search HSN or Description..."
                    className="flex-grow-1"
                    style={{ minWidth: '180px', flexBasis: '220px', maxWidth: '250px' }}
                    value={query}
                    onChange={handleSearchChange}
                  />

                  <div className="ms-auto mt-2 mt-md-0">
                    <Form.Label className="fw-bold mb-0">
                      Total number of HSN: {total_count}
                    </Form.Label>
                  </div>
                </Col>
              </Row>



              <Table responsive className="core-ui-table">
                <thead>
                  <tr>
                    <th className="text-left">HSN</th>
                    <th className="text-left">Description</th>
                    <th className="text-left">Rate</th>
                    <th className="text-left">Date</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading && (
                    <tr>
                      <td className="text-center" colSpan="5">
                        <Spinner
                          animation="border"
                          role="status"
                          className="text-center"
                          variant="primary"
                        ></Spinner>
                      </td>
                    </tr>
                  )}
                  {!loading && renderTableContent("HSN")}
                </tbody>
              </Table>
            </Tab>
            <Tab eventKey="SAC" title="SAC">
              <Row className="align-items-center py-3 px-2 mb-4 bg-light rounded shadow-sm">
                <Col xs={12} className="d-flex flex-wrap align-items-center gap-2 w-100">
                  <Button
                    className="d-flex align-items-center fw-semibold"
                    style={{ minWidth: '110px' }}
                    variant="primary"
                    onClick={() => setShowBulkImport(true)}
                  >
                    <FaPlus className="me-2" />
                    Bulk Import
                  </Button>

                  <Button
                    className="d-flex align-items-center fw-semibold"
                    style={{ minWidth: '100px' }}
                    variant="primary"
                    onClick={() => setShowAddEditModal(true)}
                  >
                    <FaPlus className="me-2" />
                    Add New
                  </Button>

                  <Form.Control
                    type="text"
                    placeholder="Search SAC or Description..."
                    className="flex-grow-1"
                    style={{ minWidth: '150px', maxWidth: '250px', flexBasis: '220px' }}
                    value={query}
                    onChange={handleSearchChange}
                  />

                  <div className="d-flex ms-auto align-items-center mt-2 mt-md-0">
                    <Form.Label className="fw-bold mb-0">
                      Total number of SAC: {total_count}
                    </Form.Label>
                  </div>
                </Col>

              </Row>
              <Table responsive className="core-ui-table">
                <thead>
                  <tr>
                    <th className="text-left">SAC</th>
                    <th className="text-left">Description</th>
                    <th className="text-left">Rate</th>
                    <th className="text-left">Date</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loading && (
                    <tr>
                      <td className="text-center" colSpan="5">
                        <Spinner
                          animation="border"
                          role="status"
                          className="text-center"
                          variant="primary"
                        ></Spinner>
                      </td>
                    </tr>
                  )}
                  {!loading && renderTableContent("SAC")}
                </tbody>
              </Table>
            </Tab>
            <Tab eventKey="QUERIES" title="Queries">
              <Row className="align-items-center py-3 px-2 mb-4 bg-light rounded shadow-sm">
                <Col className="d-flex align-items-center gap-2">
                  {/* <Form.Control
                  type="text"
                  placeholder="Search Queries"
                  className="w-auto"
                  value={query}
                  onChange={handleSearchChange}
                /> */}
                  <Form.Select
                    className="w-auto"
                    value={selectedStatus}
                    onChange={handleStatusChange}
                  >
                    <option value="">All Status</option>
                    <option value="Completed">Completed</option>
                    <option value="Pending">Pending</option>
                  </Form.Select>
                </Col>
                <Col className="d-flex justify-content-end !text-base">
                  <Form.Label
                    className="fw-bold !text-base mb-0"
                  >
                    Total number of Queries: {total_count}
                  </Form.Label>
                </Col>
              </Row>
              <Table responsive className="core-ui-table">
                <thead>
                  <tr>
                    <th className="text-left">Index</th>
                    <th className="text-left">Client</th>
                    <th className="text-left">Description</th>
                    <th className="text-left">Type</th>
                    <th className="text-left">Status</th>
                    <th className="text-left">Date</th>
                  </tr>
                </thead>
                <tbody>
                  {queryList?.length > 0 ? (
                    queryList.map((query, index) => (
                      <tr
                        key={index}
                        onClick={() => handleQueryClick(query)}
                        style={{ cursor: "pointer" }}
                      >
                        <td className="text-left">{index + 1}</td>
                        <td className="text-left">{truncateText(query.client_details?.name, 20)}</td>
                        <td className="text-left"> <DescriptionCell
                          description={query.query}
                          progressbar={false}
                        />
                        </td>
                        <td className="text-left">{query?.type || "NA"}</td>
                        <td className="text-left">{query.status === 1 ? "Completed" : "Pending"}</td>
                        <td className="text-left">{query.updated_time_formatted.split("T")[0]}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="100%"
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Tab>
            <Tab eventKey="HSN_PENDING" title="HSN Pending">
              <Row className="align-items-center py-3 px-2 mb-4 bg-light rounded shadow-sm">
                <Col className="d-flex align-items-center gap-2">
                  <Form.Control
                    type="text"
                    placeholder="Search hsn..."
                    className="w-auto"
                    value={query}
                    onChange={handleSearchChange}
                  />
                  <Button
                    className="d-flex align-items-center fw-semibold"
                    variant="success"
                    disabled={selectedRows.length === 0}
                    onClick={() => handleApproveReject(selectedRows, 1, "HSN")}
                  >
                    Bulk Approve
                  </Button>
                  <Button
                    className="d-flex align-items-center fw-semibold"
                    variant="danger"
                    disabled={selectedRows.length === 0}
                    onClick={() => handleApproveReject(selectedRows, 2, "HSN")}
                  >
                    Bulk Reject
                  </Button>
                </Col>
              </Row>
              <Table responsive className="core-ui-table">
                <thead>
                  <tr>
                    <th className="text-left">
                      <div
                        className="d-flex align-item-left g-5"
                      >
                        <Form.Check
                          type="checkbox"
                          className=" ml-4 custom-checkbox"
                          onChange={handleSelectAll}
                          checked={
                            selectedRows.length > 0 &&
                            selectedRows.length ===
                            pendingHsnSacData.filter(
                              (item) =>
                                item.action_required === 1 &&
                                item.type === "HSN"
                            ).length
                          }
                          indeterminate={
                            selectedRows.length > 0 &&
                            selectedRows.length <
                            pendingHsnSacData.filter(
                              (item) =>
                                item.action_required === 1 &&
                                item.type === "HSN"
                            ).length
                          }
                        />
                        {/* <span>Select All</span> */}
                      </div>
                    </th>
                    <th className="text-left">HSN</th>
                    <th className="text-center">Description</th>
                    <th className="text-left">Rate</th>
                    <th className="text-left">Action Type</th>
                    <th className="text-left">Date</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loading && (
                    <tr>
                      <td colSpan="5" className="text-center">
                        <Spinner
                          animation="border"
                          role="status"
                          className="text-center"
                          variant="primary"
                        ></Spinner>
                      </td>
                    </tr>
                  )}
                  {!loading && renderPendingTableContent("HSN")}
                </tbody>
              </Table>
            </Tab>
            <Tab eventKey="SAC_PENDING" title="SAC Pending">
              <Row className="align-items-center py-3 px-2 mb-4 bg-light rounded shadow-sm">
                <Col className="d-flex align-items-center gap-2">
                  <Form.Control
                    type="text"
                    placeholder="Search SAC..."
                    className="w-auto"
                    value={query}
                    onChange={handleSearchChange}
                  />
                  <Button
                    className="d-flex align-items-center fw-semibold"
                    variant="success"
                    disabled={selectedRows.length === 0}
                    onClick={() => handleApproveReject(selectedRows, 1, "SAC")}
                  >
                    Bulk Approve
                  </Button>
                  <Button
                    className="d-flex align-items-center fw-semibold"
                    variant="danger"
                    disabled={selectedRows.length === 0}
                    onClick={() => handleApproveReject(selectedRows, 2, "SAC")}
                  >
                    Bulk Reject
                  </Button>
                </Col>
              </Row>
              <Table responsive className="core-ui-table">
                <thead>
                  <tr>
                    <th className="text-left">
                      <div
                        className="d-flex align-item-left g-5"
                      >
                        <Form.Check
                          type="checkbox"
                          className=" ml-4 custom-checkbox"
                          onChange={handleSelectAll}
                          checked={
                            selectedRows.length > 0 &&
                            selectedRows.length ===
                            pendingHsnSacData.filter(
                              (item) =>
                                item.action_required === 1 &&
                                item.type === "SAC"
                            ).length
                          }
                          indeterminate={
                            selectedRows.length > 0 &&
                            selectedRows.length <
                            pendingHsnSacData.filter(
                              (item) =>
                                item.action_required === 1 &&
                                item.type === "SAC"
                            ).length
                          }
                        />
                        {/* <span>Select All</span> */}
                      </div>
                    </th>
                    <th className="text-left">SAC</th>
                    <th className="text-left">Description</th>
                    <th className="text-left">Rate</th>
                    <th className="text-left">Date</th>
                    <th className="text-left">Type</th>
                    <th className="text-left">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loading && (
                    <tr>
                      <td colSpan="5" className="text-center">
                        <Spinner
                          animation="border"
                          role="status"
                          className="text-center"
                          variant="primary"
                        ></Spinner>
                      </td>
                    </tr>
                  )}
                  {!loading && renderPendingTableContent("SAC")}
                </tbody>
              </Table>
            </Tab>
          </Tabs>
          <PaginationComponent
            total_count={total_count}
            current_page={current_page}
            handleOnClick={handlePagination}
            per_page={per_page}
          />
        </div>
        <BulkImportModal
          show={showBulkImport}
          onHide={() => {
            setShowBulkImport(false);
            setActiveTab(activeTab);
          }}
          type={activeTab}
        />
        <AddEditHsnSacModal
          show={showAddEditModal}
          onHide={() => {
            setShowAddEditModal(false);
            setEditData(null);
            setIsUpdate(false);
            setCurrentPage(1);
            setActiveTab(activeTab);
          }}
          data={editData}
          isUpdate={isUpdate}
          activeTab={activeTab}
        />

        <RoleSelectionPopup
          show={showHierarchy}
          onHide={() => {
            setShowHierarchy(false);
            setActiveTab(activeTab);
          }}
        />
      </Container>
    </Base>
  );
};

export default HsnSacComponent;
